module.exports = __webpack_public_path__ + "static/media/Selection.fe68c333.gif";